import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteEventContact($companyId: ID!, $id: ID!) {
    deleteEventContact(companyId: $companyId, id: $id) {
      eventContact {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
